module.exports = __webpack_public_path__ + "static/media/balmain-3.e7b8e502.jpg";